import { createSelector } from 'reselect'
import StoreState from 'store/state'

const contentPreviewState = (state: StoreState) => state.contentPreview
export const contentPreviewActiveSelector = createSelector(contentPreviewState, (state) => state.active)
export const contentPreviewContentSelector = createSelector(contentPreviewState, (state) => state.content)
